import { render } from "./ProductListCardComponent.vue?vue&type=template&id=4f7170cf&scoped=true"
import script from "./ProductListCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductListCardComponent.vue?vue&type=script&lang=js"

import "./ProductListCardComponent.vue?vue&type=style&index=0&id=4f7170cf&scoped=true&lang=css"
import "./ProductListCardComponent.vue?vue&type=style&index=1&id=4f7170cf&lang=css"
script.render = render
script.__scopeId = "data-v-4f7170cf"

export default script